import OutlinedInput from '@mui/material/OutlinedInput';
import { func, string } from 'prop-types';

/**
 * @component MenuInput
 * @param { Object } props
 * @param { string } props.id
 * @param { string } props.name
 * @param { string } props.value
 * @param { function } props.onHandle
 * @returns { JSX.Element }
 */
function MenuInput({ id, name, value, onHandle }) {
	const styles = {
		mui: { '& .MuiOutlinedInput-notchedOutline': { border: 'solid 0px' } },
		props: { fontSize: '0.85rem' },
	};

	return (
		<OutlinedInput
			sx={styles.mui}
			size="small"
			name={name}
			fullWidth
			value={value}
			inputProps={{ style: styles.props }}
			onChange={(e) => onHandle(e, id)}
		/>
	);
}

MenuInput.propTypes = {
	id: string,
	name: string,
	value: string,
	onHandle: func,
};

export default MenuInput;
